import React from "react";
import Nav from "./Components/Nav";
import LMHomeBody from "./Components/BodyLMHome";
import Footer from "./Components/Footer";

class LMHome extends React.Component {
  render() {
    return (
      <>
        <Nav />
        <LMHomeBody />
        <Footer />
      </>
    );
  }
}

export default LMHome;
